<div class="bog-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="bog-modal" (click)="$event.stopPropagation()">

    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="bog-header">
      <div class="bog-header__left">
        <div class="bog-header__icon-wrap">
          <img [src]="headerIconSrc" [alt]="headerTitle" class="bog-header__icon" />
        </div>
        <h2 class="bog-header__title">{{ headerTitle }}</h2>
      </div>
      <div class="bog-header__actions">
        <button class="bog-header__btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </button>
        <button class="bog-header__btn bog-header__btn--close" (click)="close()">✕</button>
      </div>
    </div>

    <!-- ── Body ───────────────────────────────────────────────────── -->
    <div class="bog-body">

      <!-- Left Column -->
      <div class="bog-col bog-col--left">

        <!-- AI Text Box -->
        <div class="bog-ai-box">
          <p class="bog-ai-box__text">{{ aiText }}</p>
        </div>

        <!-- BOG Mini Card -->
        <div class="bog-mini-card">
          <div class="bog-mini-card__header">
            <img [src]="headerIconSrc" [alt]="bogMiniCard.title" class="bog-mini-card__icon" />
            <div>
              <p class="bog-mini-card__title">{{ bogMiniCard.title }}</p>
              <p class="bog-mini-card__sub">{{ bogMiniCard.subtitle }}</p>
            </div>
          </div>

          <!-- ApexCharts sparkline -->
          <div class="bog-mini-card__chart" [style.background]="chartBg(bogScore)">
            <div #bogChartEl class="bog-apex-sparkline"></div>
            <span class="bog-mini-card__score">{{ bogScore }}%</span>
          </div>

          <!-- Bottom Performers -->
          <div class="bog-bottom-badge">{{ bottomPerformersLabel }}</div>
          <div class="bog-performers">
            <div *ngFor="let p of bottomPerformers" class="bog-performers__item">
              <span class="bog-performers__name">{{ p.name }}</span>
              <span class="bog-performers__pct">({{ p.pct }})</span>
            </div>
          </div>
        </div>

        <!-- Engagement Score (Country / Leadership / HSE) — unit view only now; country
             shows this on the always-visible summary card instead (see
             performance-indicatoors.page.html's country Boots On Ground card). -->
        @if (isUnitView) {
          <ng-template #arrowIcon let-dir>
            <svg *ngIf="dir === 'up'" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path d="M3.50391 9.5V0.5" stroke="#009146" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.50756 2L3.50378 0.5L0.5 2" stroke="#009146" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg *ngIf="dir === 'down'" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path d="M3.50391 0.5V9.5" stroke="#F00014" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.50756 8L3.50378 9.5L0.5 8" stroke="#F00014" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </ng-template>

          <div class="eng-score-card">
            <div class="eng-score-card__title">Engagement Score</div>

            <div class="eng-chart-label">{{ engCountryLabel }}</div>
            <div class="eng-chart-wrap">
              <div #engCountryChartEl class="eng-apex-chart"></div>
              <span class="eng-chart-wrap__value">{{ engCountryAvgValue }}</span>
            </div>
            <div class="eng-momyoy-row">
              <span class="eng-momyoy-row__item">
                MoM: <b>{{ formatMomYoyDisplay(engCountryMom) }}</b>
                <ng-container *ngTemplateOutlet="arrowIcon; context: { $implicit: getEngagementMomYoyArrow(engCountryMom) }"></ng-container>
              </span>
              /
              <span class="eng-momyoy-row__item">
                YoY: <b>{{ formatMomYoyDisplay(engCountryYoy) }}</b>
                <ng-container *ngTemplateOutlet="arrowIcon; context: { $implicit: getEngagementMomYoyArrow(engCountryYoy) }"></ng-container>
              </span>
            </div>

            <div class="eng-chart-label">{{ engLeadershipLabel }}</div>
            <div class="eng-chart-wrap">
              <div #engLeadershipChartEl class="eng-apex-chart"></div>
              <span class="eng-chart-wrap__value">{{ engLeadershipAvgValue }}</span>
            </div>
            <div class="eng-momyoy-row">
              <span class="eng-momyoy-row__item">
                MoM: <b>{{ formatMomYoyDisplay(engLeadershipMom) }}</b>
                <ng-container *ngTemplateOutlet="arrowIcon; context: { $implicit: getEngagementMomYoyArrow(engLeadershipMom) }"></ng-container>
              </span>
              /
              <span class="eng-momyoy-row__item">
                YoY: <b>{{ formatMomYoyDisplay(engLeadershipYoy) }}</b>
                <ng-container *ngTemplateOutlet="arrowIcon; context: { $implicit: getEngagementMomYoyArrow(engLeadershipYoy) }"></ng-container>
              </span>
            </div>

            <div class="eng-chart-label">{{ engHseLabel }}</div>
            <div class="eng-chart-wrap">
              <div #engHseChartEl class="eng-apex-chart"></div>
              <span class="eng-chart-wrap__value">{{ engHseAvgValue }}</span>
            </div>
            <div class="eng-momyoy-row">
              <span class="eng-momyoy-row__item">
                MoM: <b>{{ formatMomYoyDisplay(engHseMom) }}</b>
                <ng-container *ngTemplateOutlet="arrowIcon; context: { $implicit: getEngagementMomYoyArrow(engHseMom) }"></ng-container>
              </span>
              /
              <span class="eng-momyoy-row__item">
                YoY: <b>{{ formatMomYoyDisplay(engHseYoy) }}</b>
                <ng-container *ngTemplateOutlet="arrowIcon; context: { $implicit: getEngagementMomYoyArrow(engHseYoy) }"></ng-container>
              </span>
            </div>
          </div>
        }

      </div>

      <!-- Right Column -->
      <div class="bog-col bog-col--right">

        <!-- Main Tabs: We Talk / I See -->
        <div class="bog-tabs-wrap">
          <div class="bog-tabs">
            <button
              *ngFor="let tab of mainTabs"
              class="bog-tabs__btn"
              [class.bog-tabs__btn--active]="activeMainTab === tab.key"
              (click)="switchMainTab(tab.key)">
              <img [src]="tab.iconSrc" [width]="tab.iconWidth" [height]="tab.iconHeight" alt="" />
              {{ tab.label }}
            </button>
          </div>
          <div class="bar"></div>
        </div>

        <!-- Coaching & Feedback Frequency Card -->
        <div class="bog-freq-card">
          <div class="bog-freq-card__header-badge" [ngClass]="coachingCard.badgeClass">
            <img [src]="coachingCard.iconSrc" width="20" height="20" alt="" />
            <div>
              <span class="bog-freq-card__label">{{ coachingCard.label }}</span>
              <span class="bog-freq-card__sublabel">{{ coachingCard.sublabel }}</span>
            </div>
          </div>

          <div class="bog-freq-chart-wrap">
            <div #coachingChartEl class="bog-freq-canvas"></div>
          </div>

          <!-- Sub Tabs + Topics -->
          <div class="bog-filter-section">
            <div class="bog-sub-tabs">
              <button
                *ngFor="let st of subTabs"
                class="bog-sub-tabs__btn"
                [class.bog-sub-tabs__btn--active]="activeCoachingSubTab === st.key"
                (click)="activeCoachingSubTab = st.key">
                <img [src]="st.iconSrc" width="16" height="16" alt="" />
                <span class="bog-sub-tabs__text">{{ st.label }}</span>
              </button>
            </div>

            <ul class="topic-list">
              <li class="topic-row" *ngFor="let t of coachingTopics">
                <div class="topic-label">{{ t.label }}</div>
                <div class="topic-pct">{{ t.pct }}%</div>
                <div class="bar-wrap">
                  <div class="topic-pb">
                    <div class="topic-pb__fill" [style.width.%]="t.pct"></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- Critical Controls Frequency Card -->
        <div class="bog-freq-card">
          <div class="bog-freq-card__header-badge" [ngClass]="ccFreqCard.badgeClass">
            <img [src]="ccFreqCard.iconSrc" width="20" height="20" alt="" />
            <div>
              <span class="bog-freq-card__label">{{ ccFreqCard.label }}</span>
              <span class="bog-freq-card__sublabel">{{ ccFreqCard.sublabel }}</span>
            </div>
          </div>

          <div class="bog-freq-chart-wrap">
            <div #ccChartEl class="bog-freq-canvas"></div>
          </div>

          <!-- Sub Tabs + Topics -->
          <div class="bog-filter-section">
            <div class="bog-sub-tabs">
              <button
                *ngFor="let st of subTabs"
                class="bog-sub-tabs__btn"
                [class.bog-sub-tabs__btn--active]="activeCCSubTab === st.key"
                (click)="activeCCSubTab = st.key">
                <img [src]="st.iconSrc" width="16" height="16" alt="" />
                <span class="bog-sub-tabs__text">{{ st.label }}</span>
              </button>
            </div>

            <ul class="topic-list">
              <li class="topic-row" *ngFor="let t of ccTopics">
                <div class="topic-label">{{ t.label }}</div>
                <div class="topic-pct">{{ t.pct }}%</div>
                <div class="bar-wrap">
                  <div class="topic-pb">
                    <div class="topic-pb__fill" [style.width.%]="t.pct"></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
